/**
 * Resolves a stored image path to a fully-qualified URL.
 *
 * - External URLs (http/https) are returned as-is.
 * - Relative /uploads/ paths are prefixed with the API origin so they
 *   always load correctly whether the app is served over HTTP or HTTPS.
 */
const API_ORIGIN = process.env.REACT_APP_API_URL
  ? process.env.REACT_APP_API_URL.replace(/\/api\/?$/, '')   // strip trailing /api
  : '';                                                        // same origin in dev

const resolveImage = (path) => {
  if (!path) return null;
  if (/^https?:\/\//.test(path)) return path;          // already absolute
  if (path.startsWith('/uploads/')) return `${API_ORIGIN}${path}`;
  return path;
};

export default resolveImage;
